export enum UserSubscriptionTypesEnum {
  FREE = 'FREE',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
}

export enum UserSubscriptionTypesEnumFormatted {
  FREE = 'Grátis',
  BASIC = 'Básico',
  PREMIUM = 'Premium',
}
